import { useMutation, useQueryClient } from "@tanstack/react-query"
import { appointment } from  '@shared/api/services'

export const useRemoveAppointmentNote = (appointmentId) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: appointment.removeNote,
    onSuccess: () => {
      queryClient.invalidateQueries(['appointment', appointmentId])
    },
  })

	return mutation
}